import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { getOcelotConfig } from 'lib/configs/ocelot';
import Script from 'next/script';
import { Cts } from './Cts';
import Gtm from './Gtm';
import { Kilkaya } from './Kilkaya';
import { AnalyticsConfig, KilkayaMetadata } from './types';

const publicToolsPath = '/common/js/tools';
const analyticsConfig = getOcelotConfig('analytics');

const ctsConfig = (Object.keys(analyticsConfig) as (keyof typeof analyticsConfig)[]).reduce((acc, key) => {
  return { ...acc, [key]: analyticsConfig[key] };
}, {} as AnalyticsConfig);

export interface StandaloneTrackingProps extends StandaloneComponentProps {
  ctsData?: Record<string, string>;
  allerGaData?: Record<string, string>;
  kilkayaData?: KilkayaMetadata;
}

export const StandaloneTracking: StandaloneComponent<StandaloneTrackingProps> = ({
  ctsData,
  allerGaData,
  kilkayaData,
}) => {
  return (
    <>
      <Script id="first-party-cookie-handling" src={`${publicToolsPath}/fptools.js`} />

      <Kilkaya k5aMeta={kilkayaData}>
        {analyticsConfig?.google?.gtm && <Gtm gtmId={analyticsConfig?.google?.gtm} />}
      </Kilkaya>

      <Cts ctsData={ctsData} allerGaData={allerGaData} ctsConfig={ctsConfig} />
    </>
  );
};
